import React from 'react';
import '../styles/theme.css';
import '../styles/Crawls.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import CrawlsOpener from '../components/CrawlsOpener';
import CrawlsTable from '../components/CrawlsTable';
/* IMPORTS */

function CrawlsPage() {
  return (
    <div className="cr-root">
      <div className="cr-layout-1">
        <div id="crawlsnavbar" className="cr-slot-crawlsnavbar">
          <Navbar activePage={"Crawls"} />
        </div>
        <div className="cr-layout-2">
          <div id="crawlsopener" className="cr-slot-crawlsopener">
            <CrawlsOpener />
          </div>
          <div id="crawlstable" className="cr-slot-crawlstable">
            <CrawlsTable />
          </div>
        </div>
        <div id="crawlsfooter" className="cr-slot-crawlsfooter">
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default CrawlsPage;
